<template>
    <div>
        <div>
            <div class="flex flex-wrap">
                <div class="composer__element" @click="addSection()">
                    Add Section
                    <span class="arrow"><app-icon icon="plus" /></span>
                </div>
            </div>
        </div>
        <div v-if="items.length > 0">
            <div class="composer__ttl">
                <h3>Elements</h3>
            </div>
            <app-draggable :list="items" :clone="clone" :options="{draggable:'.element', handle:'.colHandle', group:{ name:'elements',  pull:'clone', put:'false' }}" class="flex flex-wrap">
                <div v-for="item in items" class="flex items-center composer__element colHandle element" @click="addElement(item)">
                    <div>
                        <span class="icon" v-if="item.icon">
                            <app-icon :icon="item.icon" />
                        </span>
                    </div>

                    <div class="flex-grow px-2">
                        <span>
                            {{ item.name }}
                        </span>
                    </div>

                    <div><app-icon icon="arrows-alt" /></div>
                </div>
            </app-draggable>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    components: {
        'app-draggable': draggable
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        loading: false,
    }),

    methods: {
        addElement(item) {
            this.$emit('selected', item);
        },
        addSection() {
            this.$emit('addSection');
        },
        clone(me) {
            let el = JSON.parse(JSON.stringify(me));
            el.settings = {"boxModel":{"padding":{"top":0,"right":0,"bottom":0,"left":0},"margin":{"top":0,"right":0,"bottom":0,"left":0},"border":{"top":0,"right":0,"bottom":0,"left":0,"type":"none","color":""},"borderRadius":{"topLeft":0,"topRight":0,"bottomLeft":0,"bottomRight":0}},"design":{"shadow":"","text":{"color":"","style":"","capitalisation":"","lineheight":"","spacing":"","weight":"","size":"","family":"","align":""},"background":{"url":"","color":"","media":"","attachment":"","position":"","repeat":"","size":""}},"attributes":{"classes":"","id":""}};

           return el;
        }
    },

    computed: {

    }
}
</script>

<style>
    .composer__element {
        @apply .text-base .relative .p-6 .w-full .cursor-pointer;

        border-bottom: 1px solid #e0e0e0;

        transition: all 0.2s ease-in-out;
    }

    .composer__element:hover {
        background: #eaeaea;
    }

    .composer__element .icon {
        @apply .text-base .mr-2;
    }

    .composer__element .arrow {
        @apply .absolute .text-sm;

        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/composer/Elements.vue